import lazyWithRetry from "shared/utility/lazyWithRetry";

const landingPromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-landing" */
  './components/baseFlow/Landing'
);
const currentSituationPromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-current-situation" */
  './components/baseFlow/CurrentSituation'
);
const interestRatePromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-interest-rate" */
  './components/baseFlow/InterestRate'
);
const fixedRateTermPromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-fixed-rate-term" */
  './components/baseFlow/FixedRateTerm'
);
const mortgageProviderPromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-mortgage-provider" */
  './components/baseFlow/MortgageProvider'
);
const resultsPromise = import(
  /* webpackChunkName: "bespaarcheck-baseflow-results" */
  './components/baseFlow/Results'
);
const applicantFormPromise = import(
  /* webpackChunkName: "bespaarcheck-advancedflow-applicant-form" */
  './components/advancedFlow/ApplicantForm'
);
const loanpartsPromise = import(
  /* webpackChunkName: "bespaarcheck-advancedflow-loanparts" */
  './components/advancedFlow/Loanparts'
);
const partnerFormPromise = import(
  /* webpackChunkName: "bespaarcheck-advancedflow-partner-form" */
  './components/advancedFlow/PartnerForm'
);

const PartnerForm = lazyWithRetry(() => partnerFormPromise);
const Landing = lazyWithRetry(() => landingPromise);
const CurrentSituation = lazyWithRetry(() => currentSituationPromise);
const InterestRate = lazyWithRetry(() => interestRatePromise);
const FixedRateTerm = lazyWithRetry(() => fixedRateTermPromise);
const MortgageProvider = lazyWithRetry(() => mortgageProviderPromise);
const Results = lazyWithRetry(() => resultsPromise);
const ApplicantForm = lazyWithRetry(() => applicantFormPromise);
const Loanparts = lazyWithRetry(() => loanpartsPromise);

export const baseFlow = [
  {
    component: Landing,
    url: 'landing',
  },
  {
    component: CurrentSituation,
    url: 'current-situation',
  },
  {
    component: InterestRate,
    url: 'interest-rate',
  },
  {
    component: FixedRateTerm,
    url: 'fixed-rate-term',
  },
  {
    component: MortgageProvider,
    url: 'mortgage-provider',
  },
  {
    component: Results,
    url: 'final',
    output: true,
  },
];

export const advancedFlow = [
  {
    component: Loanparts,
    url: 'loanparts',
  },
  {
    component: ApplicantForm,
    url: 'applicant',
  },
  {
    component: PartnerForm,
    url: 'partner',
  },
  {
    component: Results,
    url: 'final',
    output: true,
  },
];

export const flow = [...baseFlow, ...advancedFlow];

export default flow;
